"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _botframeworkWebchatApi = require("botframework-webchat-api");

var _react = _interopRequireDefault(require("react"));

var _ScreenReaderText = _interopRequireDefault(require("../ScreenReaderText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useLocalizer = _botframeworkWebchatApi.hooks.useLocalizer;

var ConnectivityStatusConnected = function ConnectivityStatusConnected() {
  var localize = useLocalizer();
  return /*#__PURE__*/_react.default.createElement(_ScreenReaderText.default, {
    text: localize('CONNECTIVITY_STATUS_ALT', localize('CONNECTIVITY_STATUS_ALT_CONNECTED'))
  });
};

var _default = ConnectivityStatusConnected;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VMb2NhbGl6ZXIiLCJob29rcyIsIkNvbm5lY3Rpdml0eVN0YXR1c0Nvbm5lY3RlZCIsImxvY2FsaXplIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvQ29ubmVjdGl2aXR5U3RhdHVzL0Nvbm5lY3RlZC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBob29rcyB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWFwaSc7XG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgU2NyZWVuUmVhZGVyVGV4dCBmcm9tICcuLi9TY3JlZW5SZWFkZXJUZXh0JztcblxuY29uc3QgeyB1c2VMb2NhbGl6ZXIgfSA9IGhvb2tzO1xuXG5jb25zdCBDb25uZWN0aXZpdHlTdGF0dXNDb25uZWN0ZWQgPSAoKSA9PiB7XG4gIGNvbnN0IGxvY2FsaXplID0gdXNlTG9jYWxpemVyKCk7XG5cbiAgcmV0dXJuIDxTY3JlZW5SZWFkZXJUZXh0IHRleHQ9e2xvY2FsaXplKCdDT05ORUNUSVZJVFlfU1RBVFVTX0FMVCcsIGxvY2FsaXplKCdDT05ORUNUSVZJVFlfU1RBVFVTX0FMVF9DT05ORUNURUQnKSl9IC8+O1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29ubmVjdGl2aXR5U3RhdHVzQ29ubmVjdGVkO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBQ0E7O0FBRUE7Ozs7QUFFQSxJQUFRQSxZQUFSLEdBQXlCQyw2QkFBekIsQ0FBUUQsWUFBUjs7QUFFQSxJQUFNRSwyQkFBMkIsR0FBRyxTQUE5QkEsMkJBQThCLEdBQU07RUFDeEMsSUFBTUMsUUFBUSxHQUFHSCxZQUFZLEVBQTdCO0VBRUEsb0JBQU8sNkJBQUMseUJBQUQ7SUFBa0IsSUFBSSxFQUFFRyxRQUFRLENBQUMseUJBQUQsRUFBNEJBLFFBQVEsQ0FBQyxtQ0FBRCxDQUFwQztFQUFoQyxFQUFQO0FBQ0QsQ0FKRDs7ZUFNZUQsMkIifQ==